import Collection from '~/pages/chat/models/collection';
import Message from '~/pages/chat/models/message';

export default class MessageManager extends Collection {
	constructor($q) {
		super();
		this.$q = $q;
	}

	/**
	 * Insert a message
	 *
	 * @param {*} messageObject
	 * @returns {Promise<Message>}
	 * @async
	 */
	import(messageObject) {
		const message = new Message(messageObject, this.$q);

		let result = message
			.init()
			.then(/** @type {Message} */ message_ => {
				this.set(message_.ref, message_);
				return this.get(message_.ref);
			});

		// Fetch reply if any
		if (message.reply_ref && message.reply_ref !== '0') {
			result = result
				.then(/** @type {Message} */ message_ => message_.fetchReply())
				.then(/** @type {Message} */ reply => this.import(reply))
				.then(() => this.get(message.ref));
		}

		return result;
	}
}
